import { render, staticRenderFns } from "./IssuedVisaOfficeWise.vue?vue&type=template&id=b72a330e&"
import script from "./IssuedVisaOfficeWise.vue?vue&type=script&lang=js&"
export * from "./IssuedVisaOfficeWise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports